import { Injectable, EventEmitter } from '@angular/core';

@Injectable({
    providedIn: 'root'
})
export class BookingEventService {
    public bookingCancelled$: EventEmitter<string>;

    constructor() {
        this.bookingCancelled$ = new EventEmitter<string>();
    }

    bookingCancelled(bookingId: string) {
        this.bookingCancelled$.emit(bookingId);
    }
}
